const EMOJI_UNIT =
  /(?:\p{Regional_Indicator}{2}|[0-9#*]\uFE0F?\u20E3|\p{Extended_Pictographic}\uFE0F?)\p{Emoji_Modifier}?/uy;
const MAX_DECORATIVE_MESSAGE_LENGTH = 256;

export function isEmojiOnlyMessage(value: unknown): boolean {
  if (typeof value !== 'string' || value.length > MAX_DECORATIVE_MESSAGE_LENGTH) return false;
  const text = value.replace(/\s/g, '');
  if (!text) return false;
  let offset = 0;
  while (offset < text.length) {
    EMOJI_UNIT.lastIndex = offset;
    const match = EMOJI_UNIT.exec(text);
    if (!match) return false;
    if (
      /^\p{Extended_Pictographic}/u.test(match[0]) &&
      !/^\p{Emoji_Presentation}/u.test(match[0]) &&
      !match[0].includes('\uFE0F')
    )
      return false;
    offset = EMOJI_UNIT.lastIndex;
    if (text[offset] === '\u200D') {
      offset += 1;
      if (offset === text.length) return false;
    }
  }
  return true;
}
